import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import Seo from "@/seo/Seo";
import { SeoLayout } from "@/components/site/SeoLayout";
import { BLOG, BLOG_ORDER } from "@/seo/content";
import { breadcrumbLd } from "@/seo/schema";

export default function BlogIndex() {
  const breadcrumb = [
    { name: "Home", path: "/" },
    { name: "Kennisbank", path: "/blog" },
  ];

  return (
    <>
      <Seo
        title="Kennisbank & schoonmaaktips | MyCleaner"
        description="De MyCleaner kennisbank: praktische artikelen over schoonmaak, tarieven, dieptereiniging, Airbnb schoonmaak en tips om uw woning langer schoon te houden."
        path="/blog"
        jsonLd={[breadcrumbLd(breadcrumb)]}
      />
      <SeoLayout breadcrumb={breadcrumb}>
        <span className="inline-flex items-center gap-2 rounded-full bg-blue-100 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-blue-700">
          <BookOpen className="h-3.5 w-3.5" /> Kennisbank
        </span>
        <h1 className="mt-5 font-heading text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">Schoonmaaktips & kennisbank</h1>
        <p className="mt-4 text-lg text-slate-600">Praktische artikelen over schoonmaak, tarieven en het onderhoud van uw woning.</p>

        <div className="mt-10 grid gap-6 sm:grid-cols-2">
          {BLOG_ORDER.map((slug) => {
            const b = BLOG[slug];
            return (
              <Link
                key={slug}
                to={`/blog/${slug}`}
                data-testid={`blog-card-${slug}`}
                className="group flex h-full flex-col rounded-3xl border border-slate-100 bg-white p-7 shadow-sm transition-all hover:-translate-y-1 hover:shadow-xl"
              >
                <h2 className="font-heading text-xl font-semibold text-slate-900">{b.h1}</h2>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-500">{b.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-blue-700 group-hover:gap-2">
                  Lees meer <ArrowRight className="h-4 w-4" />
                </span>
              </Link>
            );
          })}
        </div>
      </SeoLayout>
    </>
  );
}
